export enum QuickComposeOofActionStatus {
    Pending,
    Succeeded,
    Failed,
}
